import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { AnimateModule } from '@pro-connect/shared';
import { BrandSection } from '../../models/brand-section';

@Component({
  selector: 'app-brand-top',
  templateUrl: './brand-top.component.html',
  styleUrls: ['./brand-top.component.scss'],
  imports: [NgOptimizedImage, CommonModule, AnimateModule],
})
export class BrandTopComponent {
  protected readonly BrandSection = BrandSection;

  public readonly color = input.required<string>();
  public readonly backgroundColor = input.required<string>();
  public readonly brandImage = input.required<string>();
  public readonly brandLogo = input.required<string>();
  public readonly brandLogoMobile = input.required<string>();
  public readonly brandTitle = input.required<string>();
  public readonly brandDescription = input.required<string>();
  public readonly bannerClassName = input.required<string>();
}
